module.exports = __webpack_public_path__ + "static/media/sink.d1de3048.png";